function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.8,
    height: 31.395,
    viewBox: "0 0 27.8 31.395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Vrstva_430",
    "data-name": "Vrstva 430",
    transform: "translate(.15 .307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_539",
    d: "M11.625 7.625a4.125 4.125 0 1 1 4.125 4.125 4.125 4.125 0 0 1-4.125-4.125zm-.632 4.964A13.75 13.75 0 0 0 2 25.5v1.375a1.375 1.375 0 0 0 2.75 0V25.5a11 11 0 0 1 11-11 6.875 6.875 0 1 0-4.758-1.911zm10.257 5.349a5.5 5.5 0 1 0 5.5 5.5 5.5 5.5 0 0 0-5.5-5.5zm-8.25 5.5a8.25 8.25 0 1 1 8.25 8.25 8.25 8.25 0 0 1-8.25-8.25zm4.125-.344a1.375 1.375 0 0 1 1.375-1.375h1.375v-1.375a1.375 1.375 0 0 1 2.75 0v1.375H24a1.375 1.375 0 0 1 0 2.75h-1.375v1.375a1.375 1.375 0 0 1-2.75 0v-1.375H18.5a1.375 1.375 0 0 1-1.375-1.375z",
    "data-name": "Trazado 539",
    transform: "translate(-2 -.749)",
    style: {
      fill: "#acacac",
      stroke: "#f7f8f9",
      strokeWidth: ".3px",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8d7019efb684509e1583a41ef2944850.svg";
export { ForwardRef as ReactComponent };